import { render, staticRenderFns } from "./ProductCreateEdit.vue?vue&type=template&id=772e83ec&scoped=true&"
import script from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductCreateEdit.vue?vue&type=style&index=0&id=772e83ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e83ec",
  null
  
)

export default component.exports